webpackJsonp([173894859265406],{

/***/ 1696:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/designer.4a22c2ec.png";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-blk.96fbacce.png";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-wht.a1c93f19.png";

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mile-high-boys-club.bdf4ce2c.png";

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mile-high-boys-club2.7f361d2f.png";

/***/ }),

/***/ 1701:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mile-high-boys-club3.9ce32438.png";

/***/ }),

/***/ 1702:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slide1.095a8d26.jpeg";

/***/ }),

/***/ 1703:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slide2.d58120e5.jpeg";

/***/ }),

/***/ 1704:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slide2.6f018b9d.jpg";

/***/ }),

/***/ 1705:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slide3.6e2ffbb6.jpeg";

/***/ }),

/***/ 1706:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slide4.7ee854bb.jpeg";

/***/ }),

/***/ 1707:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stickers.c97341e3.jpg";

/***/ }),

/***/ 1708:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/twan-da-god.5079aeeb.jpg";

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(72);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(259);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(1131);
	
	var _mileHighBoysClub = __webpack_require__(1700);
	
	var _mileHighBoysClub2 = _interopRequireDefault(_mileHighBoysClub);
	
	var _mileHighBoysClub3 = __webpack_require__(753);
	
	var _mileHighBoysClub4 = _interopRequireDefault(_mileHighBoysClub3);
	
	var _mileHighBoysClub5 = __webpack_require__(1701);
	
	var _mileHighBoysClub6 = _interopRequireDefault(_mileHighBoysClub5);
	
	var _twanDaGod = __webpack_require__(1708);
	
	var _twanDaGod2 = _interopRequireDefault(_twanDaGod);
	
	var _stickers = __webpack_require__(1707);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _designer = __webpack_require__(1696);
	
	var _designer2 = _interopRequireDefault(_designer);
	
	var _logoWht = __webpack_require__(215);
	
	var _logoWht2 = _interopRequireDefault(_logoWht);
	
	var _logoBlk = __webpack_require__(214);
	
	var _logoBlk2 = _interopRequireDefault(_logoBlk);
	
	var _slide = __webpack_require__(1702);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _slide3 = __webpack_require__(1703);
	
	var _slide4 = _interopRequireDefault(_slide3);
	
	var _slide5 = __webpack_require__(1704);
	
	var _slide6 = _interopRequireDefault(_slide5);
	
	var _slide7 = __webpack_require__(1705);
	
	var _slide8 = _interopRequireDefault(_slide7);
	
	var _slide9 = __webpack_require__(1706);
	
	var _slide10 = _interopRequireDefault(_slide9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// components
	
	
	// css
	
	
	// static files
	
	
	//slides
	
	var backgroundArr = [_slide2.default, _slide4.default, _slide6.default, _slide8.default, _slide10.default];
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      backgroundNumber: 0,
	      homepageCollection: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.changeBackground = function changeBackground() {
	    if (this.state.backgroundNumber + 1 === backgroundArr.length) {
	      this.setState({ backgroundNumber: 0 });
	    } else {
	      this.setState({ backgroundNumber: this.state.backgroundNumber + 1 });
	    }
	  };
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    if (window.innerWidth >= 600) document.querySelector(".topBar__logo img").src = _logoBlk2.default;
	
	    if (document.querySelector(".sideBar").classList.contains("catalog")) {
	      document.querySelector(".footer__links").classList.remove("catalog");
	      document.querySelector(".sideBar").classList.remove("catalog");
	      document.querySelector(".sideBar__btn").classList.remove("catalog");
	      document.querySelectorAll("li.topBar__link a").forEach(function (el) {
	        return el.classList.remove("catalog");
	      });
	    }
	
	    document.querySelector(".sideBar__cart svg").style.stroke = "rgb(25,25,25)";
	    document.querySelector(".sideBar__cart button span").style.color = "rgb(25,25,25)";
	
	    this.props.handleCartClose();
	  };
	
	  IndexPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (window.innerWidth >= 600) document.querySelector(".topBar__logo img").src = _logoWht2.default;
	
	    document.querySelector(".sideBar__cart svg").style.stroke = "";
	    document.querySelector(".sideBar__cart button span").style.color = "";
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var backgroundNumber = this.state.backgroundNumber;
	    // console.log(this.props.collections[0]);
	
	    // let homePageItems = this.props.collections[0].
	    // if (this.props.collections[0]) {
	    //   let collectionId = this.props.collections[0].id;
	    //   this.props.client.collection.fetchWithProducts(collectionId).then((collection) => {
	    //     // Do something with the collection
	    //     console.log(collection);
	    //     console.log(collection.products);
	    //   });
	    // }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "pageWrapper" },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: "Mile High Boys Club",
	        meta: [{
	          name: "description",
	          content: "Mile High Boys Club official website and merch store."
	        }, {
	          name: "keywords",
	          content: "Mile High Boys Club, MHBC, MHBC Fashion, fashion"
	        }]
	      }),
	      _react2.default.createElement(
	        "header",
	        { id: "indexHeader" },
	        _react2.default.createElement(
	          "div",
	          { className: "header__title" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h1",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "Mile High"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "Boys Club"
	              )
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Mark of Excellence"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/en/Catalog" },
	              "Catalog ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u2192"
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: "gremlinz_link", to: "/en/Catalog/Kodak" },
	              "Gremlinz ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u2192"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "featured" },
	          _react2.default.createElement(
	            "span",
	            null,
	            "featured"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/en/Catalog" },
	            "Stylin Jacket ",
	            _react2.default.createElement(
	              "span",
	              null,
	              "\u2192"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "background" },
	          _react2.default.createElement("div", {
	            className: "background__slidingContent",
	            style: {
	              backgroundImage: "url(" + backgroundArr[backgroundNumber] + ")"
	            },
	            onAnimationIteration: function onAnimationIteration() {
	              return _this2.changeBackground();
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "main",
	        null,
	        _react2.default.createElement(
	          "div",
	          { id: "essentials" },
	          _react2.default.createElement(
	            "div",
	            { className: "essentials__item intro" },
	            _react2.default.createElement(
	              "em",
	              null,
	              "2022 collection"
	            ),
	            _react2.default.createElement(
	              "h2",
	              null,
	              "The new Kodak Collection"
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/en/Catalog/Kodak" },
	              "Shop Featured",
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u2192"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "essentials__item essentials__item_featured" },
	            _react2.default.createElement(
	              "div",
	              { className: "essentials_featured_button_wrap" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/en/Catalog/Kodak" },
	                "View collection"
	              )
	            ),
	            _react2.default.createElement("div", { className: "essentials_featured_background" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { id: "catalog_caller" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              null,
	              "browse our full catalog"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/en/Catalog" },
	              "Product Catalog",
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u2192"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { id: "designer" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("img", { src: _designer2.default })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "designer__info" },
	            _react2.default.createElement(
	              "em",
	              null,
	              "the designer"
	            ),
	            _react2.default.createElement(
	              "h2",
	              null,
	              "A world class designer, making trends and not following hype."
	            ),
	            _react2.default.createElement(
	              "button",
	              null,
	              "Learn More",
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u2192"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "productCaller" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/en/Catalog" },
	            _react2.default.createElement("div", { className: "productCaller__back" }),
	            _react2.default.createElement(
	              "div",
	              { className: "productCaller__title" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Apparel"
	              ),
	              _react2.default.createElement(
	                "button",
	                null,
	                "Browse Apparel",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "\u2192"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/en/Catalog/Accessories" },
	            _react2.default.createElement("div", { className: "productCaller__back" }),
	            _react2.default.createElement(
	              "div",
	              { className: "productCaller__title" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Accessories"
	              ),
	              _react2.default.createElement(
	                "button",
	                null,
	                "Browse Accessories",
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "\u2192"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { id: "caller" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Join our mailing list to stay up to date on new releases"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "form",
	              {
	                action: "https://milehighboysclub.us18.list-manage.com/subscribe/post?u=6a934b18b1227fc6b2773aec3&id=1e5daf0657",
	                method: "post",
	                id: "mc-embedded-subscribe-form",
	                name: "mc-embedded-subscribe-form",
	                target: "_blank",
	                noValidate: true
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "signupWrap" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mc-field-group" },
	                  _react2.default.createElement("input", {
	                    type: "email",
	                    name: "EMAIL",
	                    className: "required email",
	                    id: "mce-EMAIL"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "mce-responses", className: "clear" },
	                  _react2.default.createElement("div", {
	                    className: "response",
	                    id: "mce-error-response",
	                    style: { display: "none" }
	                  }),
	                  _react2.default.createElement("div", {
	                    className: "response",
	                    id: "mce-success-response",
	                    style: { display: "none" }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    style: { position: "absolute", left: "-5000px" },
	                    "aria-hidden": "true"
	                  },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    name: "b_6a934b18b1227fc6b2773aec3_1e5daf0657",
	                    tabIndex: "-1",
	                    value: ""
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "clear" },
	                  _react2.default.createElement("input", {
	                    type: "submit",
	                    value: "Subscribe",
	                    name: "subscribe",
	                    id: "mc-embedded-subscribe",
	                    className: "button"
	                  })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-en-js-6b60865a852d5e9146d1.js